import React from 'react';

import Text from 'components/Text';
import { Column } from 'components/Layout/Grid';
import SwitchComponent from 'components/SwitchComponent';
import TabNavigation from 'components/TabNavigation';
import { InternalUserTable } from './InternalUserTable';

const EmployeeManager: React.FC = () => {
  const viveoTabConfig = {
    label: 'Usuários Viveo',
    filter: {},
    trackingName: 'Aba_UsuariosViveo'
  };
  const viveoTabContent = 
    <Column className="w-100 max-w-lg-100 flex-1" key={1}>
      <InternalUserTable
        currentTabId="Usuários Viveo"
      />
    </Column>;

  const tabConfigList = [ viveoTabConfig ];
  const tabContentList = [ viveoTabContent ];
  
  return (
    <SwitchComponent roles={['administrator']} type={['employee','supplier']} redirect="/">
      <Text className="color-primary font-bold" size={24}>
        Gerenciar Usuários
      </Text>

      <Column className="mt-3">
        <TabNavigation
          trackingKey="Abas CTEs"
          trackingEvent="CTEs"
          tabLabels={tabConfigList}
          pages={tabContentList}
        />
      </Column>
    </SwitchComponent >
  );
};

export default EmployeeManager;
